import React, {useState} from 'react';

import {CreationSteps} from './master/creation-master';
import {isCreationComplete, useStepSummaries} from './master/use-step-summaries';
import {CharacterSheet} from './sheet/character-sheet';

import css from './character-page.module.css';

type Props = {
	/** панель над листом внутри прокрутки: ссылка на список персонажей */
	toolbar?: React.ReactNode;
};

/** лист персонажа; пока создание не закончено, вместо листа открыт конструктор */
export const CharacterWorkspace: React.FC<Props> = ({toolbar}) => {
	const steps = useStepSummaries();
	const [isConstructorOpen, setConstructorOpen] = useState(() => !isCreationComplete(steps));

	return (
		<div className={css.workspace}>
			{toolbar}
			{isConstructorOpen ? (
				<section className={css.creation}>
					<h1 className={css.creationTitle}>Конструктор персонажа</h1>
					<CreationSteps onOpenSheet={() => setConstructorOpen(false)} />
				</section>
			) : (
				<CharacterSheet onOpenConstructor={() => setConstructorOpen(true)} />
			)}
		</div>
	);
};
